import './footer.styl';

import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {setCurrentLocale} from '../../../common/intl/actions';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

const YA_MONEY = '410011619148959';
const DEFAULT_PAYMENT_AMOUT = 300;

const Footer = ({locales, domain, locale, appType, setCurrentLocale}) =>
  <div className="footer">
    <div className="footer__inner">
      <div className="donation">
        <a href="http://www.paypal.me/120" rel="nofollow" target="_blank">
          <FormattedMessage id="footer.donation" />
        </a>
        {(appType === 'international' || domain === 'poisk.in' || domain === 'poisk.co.il') &&
          <span className="donation__yandex">
            <iframe src={`https://money.yandex.ru/quickpay/button-widget?targets=${domain}&default-sum=${DEFAULT_PAYMENT_AMOUT}&button-text=14&any-card-payment-type=on&button-size=s&button-color=orange&successURL=http%3A%2F%2F${domain}&quickpay=small&account=${YA_MONEY}&lang=${locale}`} width="157" height="25" frameBorder="0" allowTransparency="true" scrolling="no"></iframe>
          </span>
        }
      </div>

      <div className="donation">
        <a
          href="https://give.wfp.org"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <FormattedMessage id="search.header.donation" />
        </a>
      </div>
      <div className="clearfix">
        <div className="footer__langs">
          {appType && appType === 'international' && locales.length > 1 && locales.map((it, key) =>
            <div
              className={classNames({
                'footer__langs-item': true,
                'footer__langs-item_current': it === locale
              })}
              key={key}
              onClick={() => setCurrentLocale(it)}
            >
              <FormattedMessage id={`languages.${it}`} />
            </div>
          )}
        </div>
        <div className="footer__right">
          {(domain === 'poisk.in' || domain === 'poisk.co.il') &&
            <div className="footer__international">
              <a href="http://clirly.com" rel="nofollow" target="_blank">
                Переход на международную версию: www.clirly.com
              </a>
            </div>
          }
        </div>
      </div>
      <div className="clearfix">
        <div className="footer__left">
          <div className="footer__copyright">
            {domain === 'clirly.com'
              ? <span>© 2017 Oleg Khokhlov</span>
              : <span>© 2017 Moshe Khokhlov</span>
            }
          </div>
        </div>
        <div className="footer__right">
          <div className="footer__contactus">
            <a href="mailto:clirglobal@gmail.com">
              <FormattedMessage id="footer.contactus" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="footer__disclaimer">
      <div className="footer__inner">
        <Link to="/legal">
          <FormattedMessage id="footer.legal" />
        </Link>
      </div>
    </div>
  </div>;

Footer.propTypes = {
  locale: React.PropTypes.string.isRequired,
  locales: React.PropTypes.array.isRequired,
  setCurrentLocale: React.PropTypes.func.isRequired
};

export default connect(state => ({
  locale: state.intl.currentLocale,
  locales: state.intl.locales,

  appType: state.config.appType,
  domain: state.device.domain,
}), {setCurrentLocale})(Footer);



// WEBPACK FOOTER //
// ./src/client/components/footer/Footer.js